import { useState, useEffect } from "react";

const QUICKSAND = "https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap";

const theme = {
  green: "#22c55e", greenLight: "#dcfce7", greenDark: "#15803d",
  red: "#ef4444", redLight: "#fee2e2", redDark: "#b91c1c",
  yellow: "#f59e0b", yellowLight: "#fef3c7", yellowDark: "#b45309",
  blue: "#3b82f6", blueLight: "#dbeafe", blueDark: "#1d4ed8",
  purple: "#8b5cf6", purpleLight: "#ede9fe", purpleDark: "#6d28d9",
  teal: "#14b8a6", tealLight: "#ccfbf1", tealDark: "#0f766e",
  gray50: "#f9fafb", gray100: "#f3f4f6", gray200: "#e5e7eb",
  gray400: "#9ca3af", gray600: "#4b5563", gray800: "#1f2937",
};

const styles = `
  @import url('${QUICKSAND}');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Quicksand', sans-serif; background: #fff; }
  .app { max-width: 700px; margin: 0 auto; min-height: 100vh; background: #fff; position: relative; padding-bottom: 80px; }
  .screen { padding: 20px 16px; }
  .btn-primary { background: ${theme.green}; color: #fff; border: none; border-radius: 16px; padding: 16px; font-family: 'Quicksand', sans-serif; font-size: 17px; font-weight: 700; cursor: pointer; width: 100%; transition: all 0.18s; }
  .btn-primary:hover { background: ${theme.greenDark}; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(34,197,94,0.3); }
  .btn-primary:active { transform: translateY(0); }
  .btn-danger { background: ${theme.red}; color: #fff; border: none; border-radius: 16px; padding: 16px; font-family: 'Quicksand', sans-serif; font-size: 17px; font-weight: 700; cursor: pointer; width: 100%; transition: all 0.18s; }
  .btn-outline { background: transparent; color: ${theme.gray800}; border: 2px solid ${theme.gray200}; border-radius: 12px; padding: 10px 16px; font-family: 'Quicksand', sans-serif; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
  .btn-outline:hover { border-color: ${theme.green}; color: ${theme.green}; background: ${theme.greenLight}; }
  .input-field { width: 100%; border: 2px solid ${theme.gray200}; border-radius: 14px; padding: 14px 16px; font-family: 'Quicksand', sans-serif; font-size: 16px; font-weight: 600; color: ${theme.gray800}; outline: none; transition: border 0.15s; background: ${theme.gray50}; }
  .input-field:focus { border-color: ${theme.green}; background: #fff; box-shadow: 0 0 0 4px ${theme.greenLight}; }
  .label { font-size: 13px; font-weight: 700; color: ${theme.gray600}; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; }
  .card { background: #fff; border: 1.5px solid ${theme.gray200}; border-radius: 20px; padding: 18px; margin-bottom: 14px; }
  .card-colored { border-radius: 20px; padding: 18px; margin-bottom: 14px; }
  .nav-bottom { position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); width: 100%; max-width: 430px; background: #fff; border-top: 1.5px solid ${theme.gray200}; display: flex; z-index: 100; padding: 8px 0 10px; }
  .nav-item { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 3px; cursor: pointer; padding: 4px 0; transition: all 0.15s; border: none; background: transparent; font-family: 'Quicksand', sans-serif; }
  .nav-icon { font-size: 22px; }
  .nav-label { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; }
  .pill { display: inline-flex; align-items: center; padding: 4px 12px; border-radius: 100px; font-size: 12px; font-weight: 700; }
  .tag-cat { padding: 10px 20px; border-radius: 100px; font-size: 14px; font-weight: 700; cursor: pointer; border: 2px solid transparent; transition: all 0.15s; white-space: nowrap; font-family: 'Quicksand', sans-serif; }
  .product-btn { border: 2px solid ${theme.gray200}; border-radius: 18px; padding: 16px 12px; text-align: center; cursor: pointer; transition: all 0.18s; background: #fff; font-family: 'Quicksand', sans-serif; }
  .product-btn:hover { border-color: ${theme.green}; box-shadow: 0 4px 16px rgba(34,197,94,0.15); transform: translateY(-2px); }
  .qty-btn { background: ${theme.gray100}; border: none; border-radius: 10px; padding: 8px 14px; font-family: 'Quicksand', sans-serif; font-size: 15px; font-weight: 700; cursor: pointer; transition: all 0.12s; color: ${theme.gray800}; }
  .qty-btn:hover { background: ${theme.greenLight}; color: ${theme.greenDark}; }
  .stat-card { border-radius: 18px; padding: 16px; text-align: center; flex: 1; }
  .alert-box { border-radius: 14px; padding: 14px; margin-bottom: 12px; display: flex; align-items: flex-start; gap: 10px; }
  .section-header { font-size: 18px; font-weight: 800; color: ${theme.gray800}; margin-bottom: 16px; }
  .divider { height: 1.5px; background: ${theme.gray200}; margin: 18px 0; border-radius: 100px; }
  .select-field { width: 100%; border: 2px solid ${theme.gray200}; border-radius: 14px; padding: 14px 16px; font-family: 'Quicksand', sans-serif; font-size: 16px; font-weight: 600; color: ${theme.gray800}; outline: none; transition: border 0.15s; background: ${theme.gray50}; appearance: none; cursor: pointer; }
  .select-field:focus { border-color: ${theme.green}; background: #fff; }
  .log-row { display: flex; align-items: center; gap: 12px; padding: 13px 0; border-bottom: 1px solid ${theme.gray100}; }
  .badge { width: 38px; height: 38px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0; }
  @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pop { 0% { transform: scale(1); } 50% { transform: scale(1.08); } 100% { transform: scale(1); } }
  .slide-up { animation: slideUp 0.35s ease forwards; }
  .pop { animation: pop 0.3s ease; }
  .toast { position: fixed; top: 24px; left: 50%; transform: translateX(-50%); background: ${theme.gray800}; color: #fff; padding: 12px 24px; border-radius: 100px; font-size: 14px; font-weight: 700; z-index: 999; font-family: 'Quicksand', sans-serif; white-space: nowrap; box-shadow: 0 8px 32px rgba(0,0,0,0.18); animation: slideUp 0.3s ease; }
  .offline-bar { background: ${theme.yellowLight}; border-bottom: 2px solid ${theme.yellow}; padding: 8px 16px; display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 700; color: ${theme.yellowDark}; }
`;

const PRODUCTS = {
  RO: [
    { id: 1, name: "20L Purified", icon: "💧", price: 20, unit: "bottle" },
    { id: 2, name: "10L RO", icon: "🫗", price: 10, unit: "bottle" },
    { id: 3, name: "5L RO", icon: "🧴", price: 5, unit: "bottle" },
  ],
  Kiosk: [
    { id: 4, name: "Raw Water", icon: "🪣", price: 3, unit: "20L" },
    { id: 5, name: "Fresh Water", icon: "🌊", price: 5, unit: "20L" },
  ],
  Delivery: [
    { id: 6, name: "Delivery Fee", icon: "🛵", price: 100, unit: "trip" },
    { id: 7, name: "20L Delivered", icon: "📦", price: 120, unit: "bottle" },
  ],
};

const EXPENSE_CATS = ["Chemicals", "Electricity", "Fuel", "Maintenance", "Staff", "Transport", "Other"];

const AUDIT_LOG = [
  { id: 1, user: "Mary W.", action: "Sale", detail: "3x 20L RO — KES 60", time: "14:32", type: "sale" },
  { id: 2, user: "Mary W.", action: "Expense", detail: "Chemicals — KES 500", time: "13:15", type: "expense" },
  { id: 3, user: "James K.", action: "Shift Open", detail: "RO: 4521, Cash: 200", time: "08:01", type: "shift" },
  { id: 4, user: "Mary W.", action: "Sale", detail: "5x Raw Water — KES 15", time: "11:44", type: "sale" },
  { id: 5, user: "James K.", action: "Voided Sale", detail: "1x 20L RO", time: "10:22", type: "void" },
];

function Toast({ msg }) {
  return msg ? <div className="toast">✓ {msg}</div> : null;
}

// ─── SCREEN 1: START DAY ───────────────────────────────────────────
function StartDayScreen({ onComplete }) {
  const [fields, setFields] = useState({ ro: "", raw: "", power: "", cash: "" });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!fields.ro) e.ro = "Required";
    if (!fields.raw) e.raw = "Required";
    return e;
  };

  const handle = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    onComplete(fields);
  };

  const now = new Date();
  const dateStr = now.toLocaleDateString("en-KE", { weekday: "long", day: "numeric", month: "long" });

  return (
    <div className="screen slide-up">
      <div style={{ textAlign: "center", marginBottom: 32, paddingTop: 12 }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: theme.gray800 }}>{dateStr}</div>
      </div>

      <div style={{ background: theme.greenLight, borderRadius: 20, padding: "18px 20px", marginBottom: 24, display: "flex", alignItems: "center", gap: 12 }}>
      
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: theme.greenDark }}>Opening Readings</div>
          <div style={{ fontSize: 12, color: theme.greenDark, opacity: 0.8 }}>Enter opening readings to begin tracking</div>
        </div>
      </div>
<div className="grid grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
      {[
        { key: "ro", label: "RO - Taps (Opening)", placeholder: "", icon: "", required: true },
        { key: "raw", label: "Kiosk Raw Opening", placeholder: "", icon: "", required: true },
        { key: "cleaning", label: "Kiosk Cleaning Opening", placeholder: "", icon: "", required: true },
        { key: "fresh", label: "Kiosk Fresh Opening", placeholder: "", icon: "", required: true },
         { key: "outlet", label: "RO Kiosk outlet- Opening", placeholder: "", icon: "", required: true },
        { key: "inlet", label: "RO Kiosk inlet- Opening", placeholder: "", icon: "", required: true },
        { key: "power", label: "Power Meter", placeholder: "", icon: "", required: true  },
        { key: "cash", label: "Opening Cash (KES)", placeholder: "", icon: "" , required: true },
      ].map(f => (
        <div key={f.key} style={{ marginBottom: 16 }}>
          <div className="label">{f.label} {f.required && <span style={{ color: theme.red }}>*</span>}</div>
          <input
            className="input-field"
            type="number"
            placeholder={f.placeholder}
            value={fields[f.key]}
            onChange={e => { setFields(p => ({ ...p, [f.key]: e.target.value })); setErrors(p => ({ ...p, [f.key]: "" })); }}
            style={errors[f.key] ? { borderColor: theme.red, background: theme.redLight } : {}}
          />
          {errors[f.key] && <div style={{ fontSize: 12, color: theme.red, fontWeight: 700, marginTop: 4 }}>⚠ {errors[f.key]}</div>}
        </div>
      ))}
      </div>

      <div style={{ marginTop: 28 }}>
        <button className="btn-primary" onClick={handle} style={{ fontSize: 18, padding: "18px" }}>
          Start Shift
        </button>
      </div>
    </div>
  );
}

// ─── SCREEN 2: POS ────────────────────────────────────────────────
function POSScreen() {
  const [cat, setCat] = useState("RO");
  const [cart, setCart] = useState([]);
  const [payment, setPayment] = useState("Cash");
  const [toast, setToast] = useState("");
  const [lastSale, setLastSale] = useState(null);
  const [showQty, setShowQty] = useState(null);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2200); };

  const addToCart = (product, qty = 1) => {
    setCart(prev => {
      const ex = prev.find(i => i.id === product.id);
      if (ex) return prev.map(i => i.id === product.id ? { ...i, qty: i.qty + qty } : i);
      return [...prev, { ...product, qty }];
    });
    setShowQty(null);
  };

  const removeItem = (id) => setCart(p => p.filter(i => i.id !== id));

  const total = cart.reduce((s, i) => s + i.price * i.qty, 0);

  const completeSale = () => {
    if (!cart.length) { showToast("Add items first"); return; }
    setLastSale([...cart]);
    setCart([]);
    showToast(`Sale of KES ${total} complete!`);
  };

  const repeatLast = () => {
    if (lastSale) { setCart([...lastSale]); showToast("Last sale repeated"); }
  };

  return (
    <div className="slide-up">
      <Toast msg={toast} />
      {/* Offline bar */}
      <div className="offline-bar">
        <span style={{ fontSize: 14 }}>📶</span>
        <span>Offline — syncing when connected</span>
      </div>

      {/* Category tabs */}
      <div style={{ display: "flex", gap: 8, padding: "16px 16px 0", overflowX: "auto", paddingBottom: 4 }}>
        {Object.keys(PRODUCTS).map(c => (
          <button key={c} className="tag-cat" onClick={() => setCat(c)}
            style={{ background: cat === c ? theme.green : theme.gray100, color: cat === c ? "#fff" : theme.gray600, borderColor: cat === c ? theme.green : "transparent" }}>
            {c === "RO" ? "💧" : c === "Kiosk" ? "🪣" : "🛵"} {c}
          </button>
        ))}
      </div>

      {/* Products */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: "16px" }}>
        {PRODUCTS[cat].map(p => (
          <div key={p.id}>
            <div className="product-btn" onClick={() => setShowQty(showQty === p.id ? null : p.id)}
              style={cart.find(i => i.id === p.id) ? { borderColor: theme.green, background: theme.greenLight } : {}}>
              <div style={{ fontSize: 32, marginBottom: 6 }}>{p.icon}</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: theme.gray800, lineHeight: 1.3 }}>{p.name}</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: theme.green, marginTop: 4 }}>KES {p.price}</div>
              <div style={{ fontSize: 11, color: theme.gray400, fontWeight: 600 }}>per {p.unit}</div>
              {cart.find(i => i.id === p.id) && (
                <div className="pill" style={{ background: theme.green, color: "#fff", marginTop: 8, justifyContent: "center" }}>
                  x{cart.find(i => i.id === p.id).qty} in cart
                </div>
              )}
            </div>
            {showQty === p.id && (
              <div style={{ background: theme.gray50, borderRadius: 14, padding: 12, marginTop: 8, border: `1.5px solid ${theme.green}` }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: theme.gray600, marginBottom: 8 }}>QTY</div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {[1, 2, 5, 10].map(q => (
                    <button key={q} className="qty-btn" onClick={() => addToCart(p, q)}>+{q}</button>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Cart */}
      {cart.length > 0 && (
        <div className="card" style={{ margin: "0 16px 12px", border: `2px solid ${theme.green}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <div style={{ fontWeight: 800, fontSize: 16, color: theme.gray800 }}>🛒 Cart</div>
            <button className="btn-outline" onClick={() => setCart([])} style={{ padding: "4px 12px", fontSize: 12, color: theme.red, borderColor: theme.red }}>Clear</button>
          </div>
          {cart.map(item => (
            <div key={item.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 8, marginBottom: 8, borderBottom: `1px solid ${theme.gray100}` }}>
              <div>
                <span style={{ fontSize: 14, fontWeight: 700 }}>{item.icon} {item.name}</span>
                <span style={{ fontSize: 13, color: theme.gray400, marginLeft: 6 }}>x{item.qty}</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontWeight: 800, color: theme.green }}>KES {item.price * item.qty}</span>
                <button onClick={() => removeItem(item.id)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16, color: theme.red }}>✕</button>
              </div>
            </div>
          ))}
          <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 4 }}>
            <span style={{ fontWeight: 700, color: theme.gray600 }}>Total</span>
            <span style={{ fontWeight: 800, fontSize: 22, color: theme.gray800 }}>KES {total}</span>
          </div>
        </div>
      )}

      {/* Payment */}
      <div style={{ padding: "0 16px" }}>
        <div className="label" style={{ marginBottom: 10 }}>💳 Payment Method</div>
        <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
          {["Cash", "M-Pesa"].map(m => (
            <button key={m} onClick={() => setPayment(m)} style={{ flex: 1, padding: "14px", border: `2px solid ${payment === m ? theme.green : theme.gray200}`, borderRadius: 14, background: payment === m ? theme.greenLight : "#fff", fontFamily: "'Quicksand', sans-serif", fontWeight: 700, fontSize: 15, cursor: "pointer", color: payment === m ? theme.greenDark : theme.gray600, transition: "all 0.15s" }}>
              {m === "Cash" ? "💵" : "📱"} {m}
            </button>
          ))}
        </div>

        <button className="btn-primary" onClick={completeSale} style={{ marginBottom: 10 }}>
          ✅ Complete Sale {cart.length > 0 && `— KES ${total}`}
        </button>

        {lastSale && (
          <button className="btn-outline" onClick={repeatLast} style={{ width: "100%", padding: "12px" }}>
            🔁 Repeat Last Sale
          </button>
        )}
      </div>
    </div>
  );
}

// ─── SCREEN 3: EXPENSES ───────────────────────────────────────────
function ExpenseScreen() {
  const [amount, setAmount] = useState("");
  const [cat, setCat] = useState("");
  const [desc, setDesc] = useState("");
  const [toast, setToast] = useState("");
  const [recent, setRecent] = useState([
    { cat: "Chemicals", amount: 500, time: "13:15" },
    { cat: "Fuel", amount: 200, time: "10:30" },
  ]);

  const save = () => {
    if (!amount || !cat) return;
    setRecent(p => [{ cat, amount: parseFloat(amount), time: new Date().toLocaleTimeString("en-KE", { hour: "2-digit", minute: "2-digit" }) }, ...p.slice(0, 4)]);
    setAmount(""); setCat(""); setDesc("");
    setToast("Expense saved!");
    setTimeout(() => setToast(""), 2000);
  };

  const quickAmounts = [100, 200, 500, 1000];

  return (
    <div className="screen slide-up">
      <Toast msg={toast} />
      <div style={{ fontSize: 22, fontWeight: 800, color: theme.gray800, marginBottom: 4 }}>Record Expense</div>
      <div style={{ fontSize: 14, color: theme.gray400, fontWeight: 600, marginBottom: 24 }}>Log today's operational costs</div>

      <div className="card" style={{ border: `2px solid ${theme.red}20` }}>
        <div className="label">💸 Amount (KES) <span style={{ color: theme.red }}>*</span></div>
        <input className="input-field" type="number" placeholder="0" value={amount} onChange={e => setAmount(e.target.value)} style={{ fontSize: 28, fontWeight: 800, textAlign: "center", marginBottom: 10 }} />

        {/* Quick amounts */}
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          {quickAmounts.map(a => (
            <button key={a} className="qty-btn" onClick={() => setAmount(String(a))} style={{ flex: 1, fontSize: 13 }}>
              {a}
            </button>
          ))}
        </div>

        <div className="label" style={{ marginTop: 8 }}>📂 Category <span style={{ color: theme.red }}>*</span></div>
        <select className="select-field" value={cat} onChange={e => setCat(e.target.value)} style={{ marginBottom: 14 }}>
          <option value="">Select category...</option>
          {EXPENSE_CATS.map(c => <option key={c} value={c}>{c}</option>)}
        </select>

        <div className="label">📝 Description (optional)</div>
        <input className="input-field" placeholder="Brief note..." value={desc} onChange={e => setDesc(e.target.value)} />
      </div>

      <button className="btn-primary" onClick={save} style={{ background: !amount || !cat ? theme.gray400 : theme.red, marginBottom: 20 }}>
        💾 Save Expense
      </button>

      {recent.length > 0 && (
        <>
          <div className="section-header" style={{ fontSize: 15 }}>Recent Expenses</div>
          {recent.map((r, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${theme.gray100}` }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 36, height: 36, background: theme.redLight, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>🧾</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: theme.gray800 }}>{r.cat}</div>
                  <div style={{ fontSize: 12, color: theme.gray400, fontWeight: 600 }}>{r.time}</div>
                </div>
              </div>
              <div style={{ fontWeight: 800, fontSize: 16, color: theme.red }}>KES {r.amount}</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

// ─── SCREEN 4: END DAY ───────────────────────────────────────────
function EndDayScreen() {
  const [inputs, setInputs] = useState({ roClose: "", rawClose: "", powerClose: "", cashHand: "", mpesa: "" });
  const [submitted, setSubmitted] = useState(false);

  const set = (k, v) => setInputs(p => ({ ...p, [k]: v }));

  // Simulated opens
  const opens = { ro: 4521, raw: 8832, power: 1204 };
  const systemSales = 1240;

  const roClose = parseFloat(inputs.roClose) || 0;
  const rawClose = parseFloat(inputs.rawClose) || 0;
  const cashHand = parseFloat(inputs.cashHand) || 0;
  const mpesa = parseFloat(inputs.mpesa) || 0;

  const litresProd = roClose > opens.ro ? (roClose - opens.ro) * 20 : 0;
  const litresSold = 62 * 20; // simulated
  const deviation = litresProd - litresSold;
  const expectedCash = systemSales;
  const actualCash = cashHand + mpesa;
  const cashDiff = actualCash - expectedCash;
  const powerUsed = parseFloat(inputs.powerClose) ? parseFloat(inputs.powerClose) - opens.power : 0;
  const powerCost = powerUsed * 22;

  const hasWaterLoss = deviation < -100;
  const hasCashMismatch = Math.abs(cashDiff) > 50;

  return (
    <div className="screen slide-up">
      <div style={{ fontSize: 22, fontWeight: 800, color: theme.gray800, marginBottom: 4 }}>Close Shift</div>
      <div style={{ fontSize: 14, color: theme.gray400, fontWeight: 600, marginBottom: 22 }}>End-of-day reconciliation</div>

      {/* Alerts */}
      {hasWaterLoss && (
        <div className="alert-box" style={{ background: theme.redLight, border: `1.5px solid ${theme.red}40` }}>
          <span style={{ fontSize: 20 }}>🚨</span>
          <div>
            <div style={{ fontWeight: 800, color: theme.redDark, fontSize: 14 }}>Water Loss Detected</div>
            <div style={{ fontSize: 13, color: theme.redDark, opacity: 0.85 }}>{Math.abs(deviation)}L unaccounted for</div>
          </div>
        </div>
      )}
      {hasCashMismatch && (
        <div className="alert-box" style={{ background: theme.yellowLight, border: `1.5px solid ${theme.yellow}40` }}>
          <span style={{ fontSize: 20 }}>⚠️</span>
          <div>
            <div style={{ fontWeight: 800, color: theme.yellowDark, fontSize: 14 }}>Cash Mismatch</div>
            <div style={{ fontSize: 13, color: theme.yellowDark, opacity: 0.85 }}>Difference of KES {Math.abs(cashDiff).toFixed(0)}</div>
          </div>
        </div>
      )}

      {/* SECTION A: Meters */}
      <div className="card" style={{ background: theme.blueLight, border: `1.5px solid ${theme.blue}30` }}>
        <div style={{ fontWeight: 800, fontSize: 15, color: theme.blueDark, marginBottom: 14 }}>📊 Meter Readings</div>
        {[
          { key: "roClose", label: "RO Closing Meter", icon: "💧", open: opens.ro },
          { key: "rawClose", label: "Raw Water Closing", icon: "🪣", open: opens.raw },
          { key: "powerClose", label: "Power Meter", icon: "⚡", open: opens.power },
        ].map(f => (
          <div key={f.key} style={{ marginBottom: 14 }}>
            <div className="label" style={{ color: theme.blueDark }}>{f.icon} {f.label} <span style={{ fontWeight: 400, fontSize: 11, color: theme.gray400 }}>opened: {f.open}</span></div>
            <input className="input-field" type="number" placeholder={String(f.open)} value={inputs[f.key]} onChange={e => set(f.key, e.target.value)} style={{ background: "#fff" }} />
          </div>
        ))}
      </div>

      {/* SECTION B: Cash */}
      <div className="card" style={{ background: theme.greenLight, border: `1.5px solid ${theme.green}30` }}>
        <div style={{ fontWeight: 800, fontSize: 15, color: theme.greenDark, marginBottom: 14 }}>💵 Cash Reconciliation</div>
        {[
          { key: "cashHand", label: "Cash in Hand (KES)", icon: "💵" },
          { key: "mpesa", label: "M-Pesa Total (KES)", icon: "📱" },
        ].map(f => (
          <div key={f.key} style={{ marginBottom: 14 }}>
            <div className="label" style={{ color: theme.greenDark }}>{f.icon} {f.label}</div>
            <input className="input-field" type="number" placeholder="0" value={inputs[f.key]} onChange={e => set(f.key, e.target.value)} style={{ background: "#fff" }} />
          </div>
        ))}
      </div>

      {/* SECTION C: Calculations */}
      <div style={{ fontWeight: 800, fontSize: 15, color: theme.gray800, marginBottom: 14 }}>📈 System Summary</div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
        {[
          { label: "Litres Produced", value: `${litresProd}L`, bg: theme.blueLight, color: theme.blueDark },
          { label: "Litres Sold", value: `${litresSold}L`, bg: theme.greenLight, color: theme.greenDark },
          { label: "Deviation", value: `${deviation > 0 ? "+" : ""}${deviation}L`, bg: deviation < 0 ? theme.redLight : theme.greenLight, color: deviation < 0 ? theme.red : theme.greenDark },
          { label: "Power Used", value: `${powerUsed.toFixed(0)} kWh`, bg: theme.yellowLight, color: theme.yellowDark },
          { label: "Expected Cash", value: `KES ${expectedCash}`, bg: theme.blueLight, color: theme.blueDark },
          { label: "Actual Cash", value: `KES ${actualCash.toFixed(0)}`, bg: theme.greenLight, color: theme.greenDark },
          { label: "Difference", value: `${cashDiff >= 0 ? "+" : ""}KES ${cashDiff.toFixed(0)}`, bg: Math.abs(cashDiff) > 50 ? theme.redLight : theme.greenLight, color: Math.abs(cashDiff) > 50 ? theme.red : theme.greenDark, span: 2 },
        ].map((s, i) => (
          <div key={i} className="stat-card" style={{ background: s.bg, gridColumn: s.span ? `span ${s.span}` : undefined }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: s.color, opacity: 0.75, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 4 }}>{s.label}</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      <button className="btn-danger" onClick={() => setSubmitted(true)} style={{ marginTop: 8 }}>
        {submitted ? "✅ Shift Closed!" : "🔒 Close Shift"}
      </button>
    </div>
  );
}

// ─── SCREEN 5: DAILY SUMMARY ─────────────────────────────────────
function SummaryScreen() {
  const stats = [
    { label: "Total Sales", value: "KES 1,240", icon: "📈", bg: theme.greenLight, color: theme.greenDark },
    { label: "Expenses", value: "KES 700", icon: "📉", bg: theme.redLight, color: theme.redDark },
    { label: "Net Income", value: "KES 540", icon: "💰", bg: theme.blueLight, color: theme.blueDark },
    { label: "Water Loss", value: "3.2%", icon: "💧", bg: theme.yellowLight, color: theme.yellowDark },
  ];

  const products = [
    { name: "20L Purified", qty: 48, revenue: 960, pct: 77 },
    { name: "Raw Water", qty: 20, revenue: 60, pct: 19 },
    { name: "Delivery", qty: 2, revenue: 220, pct: 18 },
  ];

  return (
    <div className="screen slide-up">
      <div style={{ fontSize: 22, fontWeight: 800, color: theme.gray800, marginBottom: 4 }}>Daily Summary</div>
      <div style={{ fontSize: 14, color: theme.gray400, fontWeight: 600, marginBottom: 22 }}>
        {new Date().toLocaleDateString("en-KE", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
      </div>

      {/* KPI Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24 }}>
        {stats.map((s, i) => (
          <div key={i} style={{ background: s.bg, borderRadius: 20, padding: "18px 16px" }}>
            <div style={{ fontSize: 24, marginBottom: 6 }}>{s.icon}</div>
            <div style={{ fontSize: 11, fontWeight: 700, color: s.color, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 4, opacity: 0.75 }}>{s.label}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Top Products */}
      <div style={{ fontWeight: 800, fontSize: 16, color: theme.gray800, marginBottom: 14 }}>🏆 Top Products</div>
      {products.map((p, i) => (
        <div key={i} style={{ marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: theme.gray800 }}>{p.name}</div>
            <div style={{ fontWeight: 700, fontSize: 13, color: theme.gray600 }}>KES {p.revenue} · {p.qty} units</div>
          </div>
          <div style={{ background: theme.gray100, borderRadius: 100, height: 10, overflow: "hidden" }}>
            <div style={{ width: `${p.pct}%`, background: i === 0 ? theme.green : i === 1 ? theme.blue : theme.yellow, height: "100%", borderRadius: 100, transition: "width 0.6s ease" }} />
          </div>
        </div>
      ))}

      <div className="divider" />

      {/* Quick metrics */}
      <div style={{ fontWeight: 800, fontSize: 16, color: theme.gray800, marginBottom: 14 }}>⚡ Quick Metrics</div>
      {[
        { label: "Avg sale value", value: "KES 34" },
        { label: "Total transactions", value: "36" },
        { label: "M-Pesa sales", value: "58%" },
        { label: "Litres dispensed", value: "1,240L" },
      ].map((m, i) => (
        <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "11px 0", borderBottom: `1px solid ${theme.gray100}` }}>
          <span style={{ fontSize: 14, color: theme.gray600, fontWeight: 600 }}>{m.label}</span>
          <span style={{ fontSize: 14, fontWeight: 800, color: theme.gray800 }}>{m.value}</span>
        </div>
      ))}
    </div>
  );
}

// ─── SCREEN 6: AUDIT LOG ─────────────────────────────────────────
function AuditScreen() {
  const typeConfig = {
    sale: { bg: theme.greenLight, color: theme.greenDark, icon: "🛒" },
    expense: { bg: theme.redLight, color: theme.redDark, icon: "💸" },
    shift: { bg: theme.blueLight, color: theme.blueDark, icon: "🔒" },
    void: { bg: theme.yellowLight, color: theme.yellowDark, icon: "❌" },
  };

  return (
    <div className="screen slide-up">
      <div style={{ fontSize: 22, fontWeight: 800, color: theme.gray800, marginBottom: 4 }}>Audit Log</div>
      <div style={{ fontSize: 14, color: theme.gray400, fontWeight: 600, marginBottom: 22 }}>All system actions — tamper-proof</div>

      {/* Filter pills */}
      <div style={{ display: "flex", gap: 8, marginBottom: 20, overflowX: "auto" }}>
        {["All", "Sales", "Expenses", "Shifts", "Voids"].map(f => (
          <button key={f} style={{ padding: "7px 16px", borderRadius: 100, border: `1.5px solid ${theme.gray200}`, background: f === "All" ? theme.gray800 : "#fff", color: f === "All" ? "#fff" : theme.gray600, fontFamily: "'Quicksand', sans-serif", fontWeight: 700, fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" }}>
            {f}
          </button>
        ))}
      </div>

      {AUDIT_LOG.map(log => {
        const cfg = typeConfig[log.type];
        return (
          <div key={log.id} className="log-row">
            <div className="badge" style={{ background: cfg.bg }}>
              <span style={{ fontSize: 16 }}>{cfg.icon}</span>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: theme.gray800 }}>{log.action}</div>
              <div style={{ fontSize: 12, color: theme.gray400, fontWeight: 600 }}>{log.detail}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: theme.gray600 }}>{log.time}</div>
              <div style={{ fontSize: 11, color: theme.gray400, fontWeight: 600 }}>{log.user}</div>
            </div>
          </div>
        );
      })}

      <div style={{ marginTop: 24, padding: "14px", background: theme.gray50, borderRadius: 14, textAlign: "center" }}>
        <div style={{ fontSize: 12, color: theme.gray400, fontWeight: 700 }}>🔐 36 entries today · Last sync 2 min ago</div>
      </div>
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────
const NAV = [
  { id: "start", icon: "☀️", label: "Start" },
  { id: "pos", icon: "🛒", label: "POS" },
  { id: "expense", icon: "💸", label: "Expense" },
  { id: "endday", icon: "🔒", label: "End Day" },
  { id: "summary", icon: "📊", label: "Reports" },
];

export default function WaterPOS() {
  const [screen, setScreen] = useState("start");
  const [shiftStarted, setShiftStarted] = useState(false);

  const handleStartShift = (data) => {
    setShiftStarted(true);
    setScreen("pos");
  };

  const renderScreen = () => {
    switch (screen) {
      case "start": return <StartDayScreen onComplete={handleStartShift} />;
      case "pos": return <POSScreen />;
      case "expense": return <ExpenseScreen />;
      case "endday": return <EndDayScreen />;
      case "summary": return <SummaryScreen />;
      case "audit": return <AuditScreen />;
      default: return null;
    }
  };

  return (
    <>
      <style>{styles}</style>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link href={QUICKSAND} rel="stylesheet" />
      <div className="app">
        {/* Header */}
        <div style={{ background: "#fff", borderBottom: `1.5px solid ${theme.gray100}`, padding: "14px 16px 12px", display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0, zIndex: 50 }}>
          <div>
             <div style={{ fontSize: 22, fontWeight: 800, color: theme.gray800 }}>Start Your Shift</div>
          
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {shiftStarted && <div className="pill" style={{ background: theme.greenLight, color: theme.greenDark }}>● Shift Active</div>}
            <button onClick={() => setScreen("audit")} style={{ background: theme.gray100, border: "none", borderRadius: 10, padding: "8px 12px", cursor: "pointer", fontSize: 18 }} title="Audit Log">📋</button>
          </div>
        </div>

        {/* Screen */}
        <div key={screen}>
          {renderScreen()}
        </div>

        {/* Bottom Nav */}
        <nav className="nav-bottom">
          {NAV.map(n => {
            const active = screen === n.id;
            return (
              <button key={n.id} className="nav-item" onClick={() => setScreen(n.id)}>
                <span className="nav-icon">{n.icon}</span>
                <span className="nav-label" style={{ color: active ? theme.green : theme.gray400 }}>
                  {n.label}
                </span>
                {active && <div style={{ width: 20, height: 3, background: theme.green, borderRadius: 100, marginTop: 1 }} />}
              </button>
            );
          })}
        </nav>
      </div>
    </>
  );
}